import React from "react";
import { useProfileAvatarHook } from "./profile-avatar-hooks";

type ContextProfileAvatar = ReturnType<typeof useProfileAvatarHook>;
export const ProfileAvatarContext =
  React.createContext<ContextProfileAvatar | null>(null);

export function useContextProfileAvatar() {
  const context = React.useContext(ProfileAvatarContext);

  if (!context) {
    throw new Error(
      "useContextProfileAvatar must be used within a ContextProfileAvatarProvider",
    );
  }

  return context;
}
